// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowSmallUpLeftIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ArrowSmallUpLeftIcon" ref={forwardedRef} {...props}>
      <path d="M7 13V7h6v1.5H8.5V13z" />
      <path d="m8.5 7.5 4.243 4.243-1.061 1.06-4.243-4.242z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ArrowSmallUpLeftIcon = /* @__PURE__ */ Object.assign(
  ArrowSmallUpLeftIconComponent,
  { displayName: 'ArrowSmallUpLeftIcon' },
);
